module.exports = __webpack_public_path__ + "static/media/calendar.17750571.svg";